/**
 * @name isTouchDevice
 *
 * @description Checks if the device supports touch events
 *
 * @example
 * import { isTouchDevice } from '@workbench/core';
 *
 * isTouchDevice(); // true, if called on a touch device
 */
export const isTouchDevice = (): boolean => 'ontouchstart' in window || navigator.maxTouchPoints > 0;
